// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import Switch from '../Switch';

const SwitchRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledSwitch = styled(Switch)`
  flex-direction: row-reverse;
  letter-spacing: normal;
  width: 100%;

  & *.switch-label-wrapper {
    flex: 1;
    padding-right: 0.5em;
    margin-right: 1em;
  }
`;

type ToggleOptionPropsType = {
  isToggled: boolean;
  onToggle?: (toggled: boolean) => void;
  label?: string;
};

const ToggleOption = ({ isToggled, onToggle, label = '' }: ToggleOptionPropsType) => {
  return (
    <SwitchRow>
      <StyledSwitch label={label} toggled={isToggled} onToggle={onToggle} theme={{ labelColor: '#fff' }} />
    </SwitchRow>
  );
};

export default ToggleOption;
